import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBanner = styled(Box)(({ theme }) => ({
  minHeight: 'calc(113vh - 82px)',
  position: 'relative',
  overflow: 'visible',
  width: '100%',
  padding: theme.spacing(0, '17.7%'),
  '& .homeBg': {
    // position: 'absolute',
    height: '100%',
    width: '100%',
    // background: 'red',

    '& .videoElement': {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '88%',
      width: '100%',
      objectFit: 'cover',
      zIndex: -1,
    },
  },

  '& .homeContent': {
    // position: 'absolute',
    height: '100%',
    width: '100%',
    zIndex: 1 /* Ensures content is above the video */,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    // marginTop: theme.spacing(5),
    // marginBottom: theme.spacing(15),
    // paddingBottom: theme.spacing(10),
    // paddingLeft: '20%',
    padding: theme.spacing(30, 0, 15, 0),

    '& .bannerText': {
      background: theme.customGradients.primary,
      '-webkit-background-clip': 'text',
      '-webkit-text-fill-color': 'transparent',
      boxShadow: theme.palette.boxShadow.secondary,
      font: theme.typography.h3.font,
      fontWeight: 400,
      textAlign: 'center',
    },

    [theme.breakpoints.down('lg')]: {
      paddingLeft: 1,
      '& .iconBrandLogo': {
        width: '300px',
        height: '100px',
      },
      '& .label3': {
        '@media (width: 320px)': {
          fontSize: '13.3px !important',
        },
        '@media (width: 344px)': {
          fontSize: '14.5px !important',
        },
        '@media (min-width: 320px)': {
          fontSize: '16px',
        },
        '@media (min-width: 360px)': {
          fontSize: '14.5px',
        },
        '@media (min-width: 375px)': {
          fontSize: '16px',
        },
        '@media (min-width: 376px)': {
          fontSize: '17px',
        },
        '@media (width: 390px)': {
          fontSize: '17px',
        },
      },
    },
  },

  [theme.breakpoints.down('lg')]: {
    minHeight: 'calc(90vh - 82px)',
    display: 'flex',
    // minHeight: '83vh',
    margin: theme.spacing(0),
    background: '#000000',

    '& .homeContent': {
      marginTop: theme.spacing(0),
      padding: theme.spacing(0, 0, 0, 0),
      justifyContent: 'center',
      padding: '0 20px',

      '& .bannerText': {
        margin: theme.spacing(0, 1),
        font: theme.typography.h6.font,
        fontWeight: `${500} !important`,
      },
      '& .content': {
        '@media (min-width: 768px)': {
          top: '600px'
        },
        '@media (min-width: 820px)': {
          top: '750px'
        },
        '@media (min-width: 853px)': {
          top: '800px'
        },
      },
    },
  },

  '@media (width: 320px) and (height: 568px)': {
    minHeight: 'calc(160vh - 82px) !important',
  },

  '@media (min-width: 320px)': {
    minHeight: localStorage.getItem('i18nextLng') === 'en-US' ? 'calc(212vh - 82px) !important' : 'calc(192vh - 82px) !important',
  },

  '@media (min-width: 344px)': {
    minHeight: localStorage.getItem('i18nextLng') === 'en-US' ? 'calc(118vh - 82px) !important' : 'calc(110vh - 82px) !important',
  },

  '@media (min-width: 360px)': {
    minHeight: localStorage.getItem('i18nextLng') === 'en-US' ? 'calc(120vh - 82px) !important' : 'calc(110vh - 82px) !important',
  },

  '@media (min-width: 360px) and (height: 740px)': {
    minHeight: localStorage.getItem('i18nextLng') === 'en-US' ? 'calc(127vh - 82px) !important' : 'calc(115vh - 82px) !important',
  },

  '@media (min-width: 375px)': {
    minHeight: localStorage.getItem('i18nextLng') === 'en-US' ? 'calc(140vh - 82px) !important' : 'calc(125vh - 82px) !important',
  },

  // '@media (min-width: 375px) and  (min-height: 667px)': {
  //   minHeight: 'calc(130vh - 82px)',
  // },

  '@media (min-width: 384px)': {
    minHeight: localStorage.getItem('i18nextLng') === 'en-US' ? 'calc(125vh - 82px) !important' : 'calc(110vh - 82px) !important',
  },

  '@media (min-width: 390px)': {
    minHeight: localStorage.getItem('i18nextLng') === 'en-US' ? 'calc(123vh - 82px) !important' : 'calc(107vh - 82px) !important',
  },

  '@media (min-width: 412px)': {
    minHeight: localStorage.getItem('i18nextLng') === 'en-US' ? 'calc(100vh - 82px) !important' : 'calc(95vh - 82px) !important',
  },

  '@media (min-width: 414px)': {
    minHeight: localStorage.getItem('i18nextLng') === 'en-US' ? 'calc(105vh - 82px) !important' : 'calc(105vh - 82px) !important',
  },

  '@media (min-width: 414px) and  (min-height: 736px)': {
    minHeight: localStorage.getItem('i18nextLng') === 'en-US' ? 'calc(125vh - 82px) !important' : 'calc(115vh - 82px) !important',
  },

  '@media (min-width: 414px) and  (min-height: 896px)': {
    minHeight: localStorage.getItem('i18nextLng') === 'en-US' ? 'calc(102vh - 82px) !important' : 'calc(95vh - 82px) !important',
  },

  '@media (min-width: 430px)': {
    minHeight: 'calc(95vh - 82px) !important',
  },

  '@media (min-width: 480px)': {
    minHeight: 'calc(80vh - 82px) !important',
  },

  '@media (min-width: 540px)': {
    minHeight: localStorage.getItem('i18nextLng') === 'en-US' ? 'calc(122vh - 82px) !important' : 'calc(112vh - 82px) !important',
  },

  '@media (min-width: 768px)': {
    minHeight: 'calc(105vh - 82px) !important',
  },

  '@media (min-width: 853px)': {
    minHeight: 'calc(100vh - 82px) !important',
  },

  '@media (min-width: 855px)': {
    minHeight: 'calc(115vh - 82px) !important',
  },

  '@media (min-width: 912px)': {
    minHeight: 'calc(95vh - 82px) !important',
  },

  '@media (min-width: 913px)': {
    minHeight: 'calc(115vh - 82px) !important',
  },

  '@media (min-width: 1024px) and (min-height: 1366px)': {
    minHeight: 'calc(95vh - 82px) !important',
  },

}));

export default StyledBanner;
